import React from 'react'
import ThreeDTourSvg from 'images/modules/Shared/i-3d-tour.svg?raw'

export { default as ThreeDTourUrl } from 'images/modules/Shared/i-3d-tour.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ThreeDTourSvg}} />
)
